import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Radio, RadioGroup, RadioField } from '@/components/catalyst-ui/radio'
import { Label } from '@/components/catalyst-ui/fieldset'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function AutoRenewalSettingsDialog({
  open,
  onClose,
  domainName,
  autoRenewalEnabled,
  onAutoRenewalChange,
  onSave,
  isLoading = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl p-5 !bg-[#FAFAFA]">
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">Auto Renewal Settings</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#71717A]">
          Configure auto renewal for {domainName}
        </DialogDescription>
        <div className="mt-4">
          <RadioGroup value={autoRenewalEnabled ? 'enabled' : 'disabled'} onChange={(value) => onAutoRenewalChange(value === 'enabled')} className="space-y-3">
            <RadioField>
              <Radio value="enabled" />
              <Label className="text-sm !font-medium text-[#09090B]">Enable Auto Renewal</Label>
            </RadioField>
            <RadioField>
              <Radio value="disabled" />
              <Label className="text-sm !font-medium text-[#09090B]">Disable Auto Renewal</Label>
            </RadioField>
          </RadioGroup>
          <p className="text-sm font-medium text-[#A1A1AA] mt-3">
            When auto renewal is enabled, your domain will be automatically renewed before expiration.
          </p>
        </div>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button 
          onClick={onClose}
          outline
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          color="dark"
          disabled={isLoading}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
